import { render } from "./compareplan.vue?vue&type=template&id=4dc5eed5&scoped=true"
import script from "./compareplan.vue?vue&type=script&lang=js"
export * from "./compareplan.vue?vue&type=script&lang=js"

import "./compareplan.vue?vue&type=style&index=0&id=4dc5eed5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc5eed5"]])

export default __exports__